import { createPortal } from 'react-dom';

import { useDismissable } from './useDismissable';

export interface PaneScrimProps {
  onDismiss: () => void;
}

/**
 * The tap-outside target for an open slide-out pane. Invisible by design - see shell.css.
 *
 * Portaled to <body> for the reason Modal spells out: both panes live inside a `--z-chrome`
 * stacking context (`.shell__left` for Kho bài, `.panel` itself for Sổ đầu bài), so a scrim
 * rendered beside them ranks at 10 against the world outside and `.wb-toolbar` paints over it.
 * From <body> its `--z-scrim` is read at face value, and shell.css lifts the open pane past it.
 */
export function PaneScrim({ onDismiss }: PaneScrimProps) {
  const dismiss = useDismissable(true, onDismiss);
  if (typeof document === 'undefined' || !document.body) return null;
  return createPortal(<div className="pane-scrim" role="presentation" {...dismiss} />, document.body);
}

export default PaneScrim;
